import { getElapsedTimePercent } from "./utils/getElapsedTimePercent.js";
import { getProgressBarBackground } from "./utils/getProgressBarBackground.js";
import { useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/ShiftProgressBar/index.tsx
var getProgressBarStyle = ({ backgroundColor, color, endTime, startTime }) => {
	const elapsedTimePercent = startTime && endTime ? `${getElapsedTimePercent(startTime, endTime)}%` : "100%";
	return getProgressBarBackground(elapsedTimePercent, color, backgroundColor);
};
function ShiftProgressBar({ backgroundColor, children, className, color, endTime, startTime }) {
	const [progressBarStyle, setProgressBarStyle] = useState();
	useEffect(() => {
		setProgressBarStyle(getProgressBarStyle({
			backgroundColor,
			color,
			endTime,
			startTime
		}));
		const interval = setInterval(() => {
			setProgressBarStyle(getProgressBarStyle({
				backgroundColor,
				color,
				endTime,
				startTime
			}));
		}, 6e4);
		return () => {
			clearInterval(interval);
		};
	}, [
		backgroundColor,
		color,
		endTime,
		startTime
	]);
	return /* @__PURE__ */ jsx("div", {
		className,
		style: { background: progressBarStyle },
		children
	});
}
//#endregion
export { ShiftProgressBar };

//# sourceMappingURL=index.js.map